module.exports = __webpack_public_path__ + "img/full_logo_white.7e0f55c7.png";